import EntityImageActions from '../../entityImage/EntityImageActions';

const MetierImageActions = () => <EntityImageActions entityType="metier" />;

export default MetierImageActions;
